import { ApiConfig } from "../../../Api/Api";

export const getTopicDataApi = async () => {
  return await ApiConfig.get(`api/topics`);
};
